<template>
  <div class="block-box">
    <el-dialog title="官方认证审核" :visible.sync="dialogVisible" width="500px" :before-close="handleClose" :close-on-click-modal="false">
      <el-form ref="form" :model="params" :rules="rules" label-width="85px">
        <el-form-item label="审核:" prop="processingStatus">
          <el-select v-model="params.processingStatus" clearable size="small">
            <el-option v-for="item in typeList" :key="item.code" :label="item.value" :value="item.code"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="回执:" prop="processedReceipt">
          <el-input type="textarea" v-model="params.processedReceipt"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')" :loading="flag" size="small">确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import API from '@/api'
export default {
  data() {
    return {
      dialogVisible: false,
      flag: false,
      params: {
        id: '',
        processingStatus: undefined,
        processedReceipt: '',
      },
      rules: {
        processingStatus: [
          { required: true, message: '请选择状态', trigger: 'blur' },
        ],
      },
      typeList: [
        { value: '未审核', code: 1 },
        { value: '已通过', code: 2 },
        { value: '已拒绝', code: 3 },
      ],
    }
  },
  methods: {
    // 表单验证提交
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.flag = true
          this.editOfficial()
        } else {
          return false;
        }
      });
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.params = {
        processingStatus: undefined,
        processedReceipt: '',
        id: '',
      }
      this.$refs['form'].resetFields()
    },
    // 打开限制弹窗、传递需要编辑的参数
    open(data) {
      this.dialogVisible = true
      this.params.id = data.id
      this.params.processingStatus = data.processingStatus
      this.params.processedReceipt = data.processedReceipt
    },
    // 编辑
    editOfficial() {
      API.editOfficial(this.params).then(res => {
        if (res.code === 200) {
          this.$message({
            message: '操作成功',
            type: 'success'
          });
          this.$emit('handlerClose')
        } else {
          this.$message.error('操作失败');
        }
        this.handleClose();
        this.flag = false
      }).catch(() => {
        this.handleClose();
        this.flag = false
      })
    },
  }
}
</script>

<style lang="scss" >
.block-box {
  .el-input--small {
    width: 200px;
  }
  .el-select {
    width: 150px !important;
  }
  .avatar-uploader {
    width: 150px;
    height: 150px;
  }
  .el-upload {
    width: 100%;
    height: 100%;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    &:hover {
      border: 1px dashed #e63765;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 150px;
    text-align: center;
    &:hover {
      color: 1px dashed #e63765 !important;
    }
  }
}
</style>
